import * as React from "react";
import Svg, { Path } from "react-native-svg";
const VacationIcon = (props) => (
  <Svg
    width={195}
    height={107}
    viewBox="0 0 195 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      opacity={0.05}
      d="M97.2489 106.304C150.958 106.304 194.498 103.747 194.498 100.594C194.498 97.4409 150.958 94.8847 97.2489 94.8847C43.5398 94.8847 0 97.4409 0 100.594C0 103.747 43.5398 106.304 97.2489 106.304Z"
      fill="black"
    />
    <Path
      d="M164.986 100.995C159.878 100.858 155.847 96.5748 155.983 91.4286C156.12 86.2825 160.371 82.2219 165.479 82.3591C170.588 82.4962 174.618 86.7792 174.482 91.9253C174.346 97.0715 170.095 101.132 164.986 100.995Z"
      fill="#E40046"
    />
    <Path
      opacity={0.5}
      d="M159.728 96.9279C156.216 93.1878 155.833 87.8078 158.873 84.9114C161.912 82.015 167.223 82.699 170.735 86.4391C174.247 90.1793 174.63 95.5593 171.59 98.4557C168.551 101.352 163.24 100.668 159.728 96.9279Z"
      fill="white"
    />
    <Path
      d="M161.613 95.1317C158.101 91.3916 156.874 86.8157 158.873 84.9112C160.871 83.0067 165.338 84.4948 168.85 88.235C172.362 91.9752 173.589 96.551 171.59 98.4555C169.592 100.36 165.125 98.8719 161.613 95.1317Z"
      fill="#E40046"
    />
    <Path
      opacity={0.5}
      d="M163.686 93.156C160.174 89.4158 158.019 85.7245 158.873 84.9111C159.726 84.0977 163.265 86.4704 166.777 90.2105C170.289 93.9507 172.444 97.642 171.59 98.4554C170.737 99.2688 167.198 96.8962 163.686 93.156Z"
      fill="white"
    />
    <Path
      d="M41.6367 97.6636C41.9376 97.6636 42.2385 97.5626 42.4893 97.3605L130.66 21.5214C131.212 21.0162 131.312 20.1572 130.811 19.6014C130.309 19.0457 129.457 18.9446 128.905 19.4499L40.784 95.2889C40.2323 95.7942 40.132 96.6531 40.6336 97.2089C40.8844 97.512 41.2856 97.6636 41.6367 97.6636Z"
      fill="#3E1717"
    />
    <Path
      d="M99.4143 97.6636C99.7152 97.6636 100.016 97.5626 100.267 97.3605C100.668 97.0573 100.869 96.5521 100.768 96.0468L92.3426 53.6052C92.1921 52.8474 91.4899 52.3926 90.7376 52.5442C89.9853 52.6958 89.5339 53.4031 89.6844 54.161L97.5586 93.9247L51.5672 72.7545C50.8651 72.4513 50.1128 72.7545 49.7617 73.4113C49.4607 74.1186 49.7617 74.8765 50.4137 75.2302L98.8124 97.512C99.0131 97.6131 99.2137 97.6636 99.4143 97.6636Z"
      fill="#220909"
    />
    <Path
      d="M129.757 20.4604H172.84C161.656 39.6601 130.71 79.5754 100.016 79.5754H62.4506C86.7252 79.5754 118.623 39.7107 129.757 20.4604Z"
      fill="#494141"
    />
    <Path
      d="M123.338 25.8161L123.037 25.4624L122.686 25.0582C122.435 24.8056 122.234 24.553 121.983 24.2498C121.532 23.694 121.031 23.1383 120.629 22.5825C119.727 21.4709 118.924 20.2583 118.122 19.0962C117.72 18.4899 117.369 17.8836 117.068 17.2773C116.717 16.671 116.416 16.0647 116.115 15.4078C115.564 14.1447 115.112 12.8815 114.811 11.6184L114.009 14.4478C114.26 14.0942 114.912 13.4878 115.714 12.9826C116.517 12.4773 117.369 11.9721 118.272 11.4668C119.175 10.9616 120.128 10.5068 121.131 10.0521L124.09 8.73843L124.14 8.68791C125.093 8.28371 125.494 7.17214 125.093 6.21215C124.792 5.50479 124.04 5.10059 123.338 5.10059C122.134 5.15111 120.98 5.30269 119.827 5.45426C118.673 5.65637 117.52 5.85847 116.366 6.21215C115.213 6.5153 114.009 6.91951 112.855 7.42477C111.652 7.98055 110.448 8.58686 109.144 9.90052C108.442 10.6079 108.191 11.5173 108.291 12.4268L108.342 12.73C108.592 14.5994 109.044 16.3678 109.696 18.0857C110.298 19.8036 111.1 21.3698 111.953 22.8856C112.805 24.4014 113.808 25.8666 114.862 27.2308C115.413 27.8877 115.915 28.595 116.517 29.2519C116.818 29.555 117.068 29.9087 117.419 30.2118L117.871 30.6666L118.372 31.1718C119.827 32.5866 122.184 32.5866 123.588 31.0708C124.993 29.6561 124.993 27.3824 123.639 25.9172L123.338 25.8161Z"
      fill="#FFC3BD"
    />
    <Path
      d="M122.084 5.25218L126.397 4.6964L127.852 9.95107C127.852 9.95107 123.488 11.0626 121.632 8.23319L122.084 5.25218Z"
      fill="#FFC3BD"
    />
    <Path
      d="M129.757 4.6964L130.309 9.04161L127.801 9.95107L126.397 4.6964H129.757Z"
      fill="#FFC3BD"
    />
    <Path
      d="M117.068 67.0956C117.068 67.0956 128.754 57.9504 138.635 40.2665C140.992 36.0728 139.086 30.7676 134.622 29.0498C130.911 27.635 126.899 26.2709 123.588 25.2098C120.278 24.1488 116.667 25.3614 114.711 28.2919C110.649 34.355 106.687 42.8938 94.2984 53.1505C93.5963 53.7568 93.6966 54.8684 94.499 55.3231L117.068 67.0956Z"
      fill="#407BFF"
    />
    <Path
      d="M117.068 67.0956C117.068 67.0956 128.754 57.9504 138.635 40.2665C140.992 36.0728 139.086 30.7676 134.622 29.0498C130.911 27.635 126.899 26.2709 123.588 25.2098C120.278 24.1488 116.667 25.3614 114.711 28.2919C110.649 34.355 106.687 42.8938 94.2984 53.1505C93.5963 53.7568 93.6966 54.8684 94.499 55.3231L117.068 67.0956Z"
      fill="#E40046"
    />
    <Path
      opacity={0.2}
      d="M139.537 37.9928C138.083 33.395 136.829 34.7592 136.227 35.2139C131.764 38.8012 129.406 46.5316 129.858 53.5547C132.717 49.8663 135.776 45.3695 138.685 40.2159C139.086 39.458 139.387 38.7507 139.537 37.9928Z"
      fill="black"
    />
    <Path
      d="M138.585 16.9741C136.227 19.9551 132.666 25.614 133.82 28.6961C131.162 29.7571 128.203 30.2624 124.291 28.8476C120.379 27.4329 121.683 26.0687 123.438 25.1087C127.5 25.715 128.955 22.5825 129.657 19.753L138.585 16.9741Z"
      fill="#FFC3BD"
    />
    <Path
      opacity={0.2}
      d="M129.607 19.8035L134.622 18.2372C134.522 18.793 133.97 21.0667 133.268 22.0772C132.215 23.694 129.356 24.6035 127.25 24.1993C128.554 23.1888 129.206 21.4204 129.607 19.8035Z"
      fill="black"
    />
    <Path
      d="M127.852 5.35321C126.046 6.81845 125.193 10.2037 125.845 12.5279C129.105 7.32371 129.156 5.75742 129.156 5.75742L127.852 5.35321Z"
      fill="#263238"
    />
    <Path
      d="M139.086 12.6289C137.932 17.3783 137.481 20.2078 134.622 22.3298C130.309 25.5635 124.792 22.5825 124.541 17.6309C124.291 13.1847 126.247 6.16162 131.262 4.89848C136.227 3.63533 140.29 7.87949 139.086 12.6289Z"
      fill="#FFC3BD"
    />
    <Path
      d="M138.284 16.9741C137.03 15.2562 136.478 11.9216 137.18 9.4458C134.171 8.68791 124.842 8.13213 127.4 3.07956C129.958 -1.97301 133.419 0.300651 133.469 2.11957C139.186 0.452228 142.998 2.3722 141.443 4.09007C147.311 6.21215 145.255 11.0121 143.951 11.6184C146.007 14.0436 145.105 19.5509 141.895 19.652C138.735 19.753 137.331 22.2288 135.525 21.5214C135.926 19.7025 138.284 16.9741 138.284 16.9741Z"
      fill="#263238"
    />
    <Path
      d="M132.165 13.1342C132.115 13.4879 131.864 13.791 131.663 13.7405C131.413 13.69 131.262 13.3868 131.312 13.0331C131.362 12.6795 131.613 12.3763 131.814 12.4268C132.065 12.4774 132.215 12.7805 132.165 13.1342Z"
      fill="#263238"
    />
    <Path
      d="M127.701 12.2752C127.651 12.6289 127.4 12.9321 127.2 12.8815C126.949 12.831 126.798 12.5279 126.849 12.1742C126.899 11.8205 127.149 11.5174 127.35 11.5679C127.601 11.5679 127.751 11.9216 127.701 12.2752Z"
      fill="#263238"
    />
    <Path
      d="M140.541 17.6815C139.788 18.6414 138.735 19.1467 137.732 19.2983C136.277 19.5004 135.826 18.1867 136.478 16.9236C137.03 15.812 138.484 14.3468 139.788 14.7004C141.142 15.1046 141.393 16.6204 140.541 17.6815Z"
      fill="#FFC3BD"
    />
    <Path
      d="M129.156 12.6794C129.156 12.6794 127.852 14.8015 126.698 15.7615C127.25 16.5194 128.504 16.3678 128.504 16.3678L129.156 12.6794Z"
      fill="#ED847E"
    />
    <Path
      d="M130.359 18.3383C131.864 18.3383 132.767 17.3783 132.817 17.3278C132.867 17.2773 132.867 17.2267 132.817 17.1762C132.767 17.1257 132.717 17.1257 132.666 17.1762C132.666 17.1762 131.613 18.2878 129.908 18.0351C129.858 18.0351 129.808 18.0857 129.757 18.1362C129.757 18.1867 129.808 18.2373 129.858 18.2878C130.008 18.3383 130.159 18.3383 130.359 18.3383Z"
      fill="#263238"
    />
    <Path
      d="M134.823 11.77C134.873 11.77 134.923 11.77 134.923 11.7194C135.024 11.6689 135.074 11.5173 135.024 11.4163C134.422 10.3047 133.369 10.2037 133.318 10.2037C133.168 10.2037 133.068 10.3047 133.068 10.4058C133.068 10.5573 133.168 10.6584 133.268 10.6584C133.318 10.6584 134.121 10.7089 134.622 11.6184C134.673 11.7194 134.773 11.77 134.823 11.77Z"
      fill="#263238"
    />
    <Path
      d="M126.196 10.5573C126.247 10.5573 126.347 10.5573 126.397 10.5068C127.149 9.79946 127.952 9.90051 128.002 9.90051C128.102 9.90051 128.253 9.84999 128.303 9.69841C128.353 9.59736 128.253 9.44579 128.152 9.44579C128.102 9.44579 127.049 9.24368 126.146 10.1531C126.046 10.2542 126.046 10.4058 126.146 10.4563C126.096 10.5574 126.146 10.5573 126.196 10.5573Z"
      fill="#263238"
    />
    <Path
      d="M45.6489 94.7331L39.9313 93.6721L54.0748 80.586L58.037 86.2953L45.6489 94.7331Z"
      fill="#FFC3BD"
    />
    <Path
      d="M45.8495 97.8657C46.3009 96.552 45.9498 94.7836 47.2538 92.7626C47.2538 92.7626 44.2446 89.6805 42.9907 91.0447C41.7369 92.4089 37.8249 93.7731 33.1104 92.6616C32.4584 92.51 32.2578 94.531 33.7122 95.0363C36.1698 95.8952 37.9753 96.5015 40.0818 97.2089C41.8873 97.8152 42.1883 98.371 43.5926 98.9773C44.7963 99.432 45.3981 99.1794 45.8495 97.8657Z"
      fill="#FFC3BD"
    />
    <Path
      d="M99.6649 57.9504C99.6649 57.9504 81.0076 60.4767 70.0238 64.3672C62.7515 66.944 48.9591 84.1733 48.9591 84.1733L54.5262 89.7816C54.5262 89.7816 68.3687 80.5859 78.4999 75.5839C96.2544 79.1207 114.26 80.2828 117.018 67.045C112.956 64.3672 99.6649 57.9504 99.6649 57.9504Z"
      fill="#3778A8"
    />
    <Path
      opacity={0.2}
      d="M72.8324 64.1651L74.7383 77.6049C71.6287 79.2723 68.4189 81.1417 65.5099 82.9101L72.8324 64.1651Z"
      fill="black"
    />
    <Path
      d="M46.1504 84.5269L54.1751 92.51L56.8834 89.8827L48.608 81.3943L46.1504 84.5269Z"
      fill="#E40046"
    />
    <Path
      d="M94.148 53.8579C94.148 53.8579 72.9829 46.9864 62.0493 50.8768C54.777 53.4536 61.4976 77.8575 61.4976 77.8575L71.4281 79.0702C71.4281 79.0702 72.5315 69.3187 73.4343 64.3672C82.4119 68.1566 108.843 76.1902 111.551 62.9525C107.439 60.2746 94.148 53.8579 94.148 53.8579Z"
      fill="#3778A8"
    />
    <Path
      d="M67.466 92.51L62.7014 92.7121L63.1026 76.7965L70.074 77.2512L67.466 92.51Z"
      fill="#FFC3BD"
    />
    <Path
      d="M69.1711 95.5415C68.7699 94.2279 67.4659 92.9647 67.3154 90.59C67.3154 90.59 63.1025 89.8827 62.8517 91.7016C62.6511 93.5205 60.2938 96.9562 55.78 98.8762C55.1781 99.1288 56.131 100.897 57.6357 100.443C60.1434 99.6846 61.9489 99.0783 64.0554 98.4215C65.861 97.8657 66.4628 98.1183 67.9173 97.7647C69.2213 97.4615 69.5724 96.9057 69.1711 95.5415Z"
      fill="#FFC3BD"
    />
    <Path
      d="M60.4945 79.3228L71.6287 81.0912L72.3309 77.4028L60.6951 75.3313L60.4945 79.3228Z"
      fill="#E40046"
    />
    <Path
      d="M132.516 36.1233C132.215 39.4075 131.964 42.7927 131.563 46.0769C131.413 47.7442 131.162 49.3611 130.961 50.9779C130.71 52.5442 130.409 54.161 130.058 55.4241C129.958 55.7273 129.858 56.0304 129.808 56.182C129.757 56.2831 129.757 56.3336 129.757 56.2831C129.757 56.2831 129.757 56.2831 129.858 56.182C129.908 56.1315 129.908 56.081 129.958 56.081L130.058 56.0305C130.109 56.0305 130.109 55.9799 130.159 55.9799L130.209 55.9294C130.259 55.9294 130.259 55.8789 130.309 55.8789C130.359 55.8284 130.359 55.8789 130.259 55.9294C130.209 55.9799 130.058 56.0305 129.958 56.081C129.707 56.182 129.356 56.2831 129.055 56.3841C128.353 56.5357 127.601 56.6873 126.798 56.8389C125.996 56.9904 125.193 57.0915 124.391 57.1925C121.131 57.5967 117.771 57.8494 114.41 58.2031H114.36C113.357 58.3041 112.605 59.2136 112.705 60.2241C112.805 61.083 113.457 61.7399 114.21 61.8409C117.67 62.4472 121.081 62.7504 124.592 62.8514C126.347 62.9019 128.102 62.9019 130.058 62.6493C130.56 62.5988 131.061 62.4977 131.613 62.3967C131.914 62.3462 132.165 62.2451 132.516 62.1441C132.817 62.043 133.168 61.8914 133.619 61.6388C133.72 61.5883 133.82 61.4872 133.97 61.4367L134.171 61.2851L134.372 61.1335C134.422 61.083 134.522 61.0325 134.572 60.9314C134.673 60.8809 134.723 60.7799 134.773 60.6788C134.923 60.4767 134.973 60.4262 135.074 60.3251C135.375 59.9715 135.525 59.6683 135.726 59.3652C136.027 58.7588 136.278 58.2536 136.478 57.7483C136.879 56.7378 137.13 55.8283 137.381 54.9189C137.632 54.0094 137.832 53.1505 137.983 52.241C138.334 50.4726 138.635 48.7548 138.886 46.9864C139.387 43.5001 139.738 40.0643 139.889 36.5275C139.989 34.456 138.434 32.7381 136.378 32.6371C134.372 32.536 132.666 34.0518 132.516 36.0223V36.1233Z"
      fill="#FFC3BD"
    />
    <Path
      d="M115.012 57.9504L110.799 57.142L111 62.6999C111 62.6999 115.764 63.1041 116.517 60.9315L116.115 59.062C116.015 58.5062 115.564 58.0515 115.012 57.9504Z"
      fill="#FFC3BD"
    />
    <Path
      d="M107.64 57.4957L106.085 61.5883L111.05 62.6999L110.799 57.142L107.64 57.4957Z"
      fill="#FFC3BD"
    />
    <Path
      d="M84.7691 97.6636C85.0701 97.6636 85.371 97.5626 85.6218 97.3605L173.743 21.5214C174.294 21.0162 174.395 20.1572 173.893 19.6014C173.392 19.0457 172.539 18.9446 171.987 19.4499L83.8664 95.2889C83.3147 95.7942 83.2144 96.6531 83.7159 97.2089C83.9667 97.512 84.3679 97.6636 84.7691 97.6636Z"
      fill="#3E1717"
    />
    <Path
      d="M142.497 97.6636C142.798 97.6636 143.098 97.5626 143.349 97.3605C143.75 97.0573 143.951 96.5521 143.851 96.0468L135.425 53.6052C135.274 52.8474 134.572 52.3926 133.82 52.5442C133.068 52.6958 132.616 53.4031 132.767 54.161L140.641 93.9247L94.6495 72.7545C93.9474 72.4513 93.1951 72.7545 92.844 73.4113C92.5431 74.1186 92.844 74.8765 93.496 75.2302L141.895 97.512C142.095 97.6131 142.296 97.6636 142.497 97.6636Z"
      fill="#3E1717"
    />
  </Svg>
);
export default VacationIcon;
